import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FundingSidebar"] */ "/vercel/path0/components/Funding/FundingSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketplaceCards"] */ "/vercel/path0/components/Funding/MarketplaceCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProposalFeed"] */ "/vercel/path0/components/Funding/ProposalFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProposalSortAndFilters"] */ "/vercel/path0/components/Funding/ProposalSortAndFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitProposalTooltip"] */ "/vercel/path0/components/tooltips/SubmitProposalTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/components/ui/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroHeader"] */ "/vercel/path0/components/ui/HeroHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
